import { ref } from 'vue';

export const showing_reference_partstudio_modal = ref(false);

export function show_import_ref_partstudio_modal() {
    showing_reference_partstudio_modal.value = true;
}

export function hide_import_ref_partstudio_modal() {
    showing_reference_partstudio_modal.value = false;
}
